import { dispatch } from './marker.js';
import { traverse } from './tree/traverse.js';
import { graft } from './tree/mutate.js';

function resolveArray(state, path) {
  let arr = traverse(state, path);
  if (arr === undefined) {
    arr = [];
    graft(state, path, arr);
  } else if (!Array.isArray(arr)) {
    throw new TypeError(`Expected array at path "${path.join('.')}", got ${typeof arr}`);
  }
  return arr;
}

export function push(state, marker, value, method, cb) {
  let shouldCallCallback = false;
  try {
    return dispatch(marker, {
      path: ({ path }) => {
        const arr = resolveArray(state, path);
        arr.push(value);
        shouldCallCallback = true;
        return value;
      }
    });
  } catch (error) {
    console.error(error);
    return undefined;
  } finally {
    if (shouldCallCallback && cb) {
      cb(marker, method, value, undefined);
    }
  }
}

export function unshift(state, marker, value, method, cb) {
  let shouldCallCallback = false;
  try {
    return dispatch(marker, {
      path: ({ path }) => {
        const arr = resolveArray(state, path);
        arr.unshift(value);
        shouldCallCallback = true;
        return value;
      }
    });
  } catch (error) {
    console.error(error);
    return undefined;
  } finally {
    if (shouldCallCallback && cb) {
      cb(marker, method, value, undefined);
    }
  }
}

export function splice(state, marker, spliceArgs, method, cb) {
  let removed;
  let shouldCallCallback = false;
  try {
    return dispatch(marker, {
      path: ({ path }) => {
        const arr = resolveArray(state, path);
        removed = arr.splice(...spliceArgs);
        shouldCallCallback = true;
        return removed;
      }
    });
  } catch (error) {
    console.error(error);
    return undefined;
  } finally {
    if (shouldCallCallback && cb) {
      cb(marker, method, spliceArgs, removed);
    }
  }
}
